module.exports = require("dompurify");


//////////////////
// WEBPACK FOOTER
// external "dompurify"
// module id = 643
// module chunks = 0